<template>
  <div class="registration scrollable-div">
    <div class="header">
      <div class="header">
        <div class="col align-self-center">
          <Logo/>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div>
        <div class="col align-self-center">
          <div class="row header text-center">
            <div class="col align-self-center">
              <h2 v-if="stepCounter <= 1">{{ $t('registration.h2') }}</h2>
            </div>
          </div>
          <div class="row main">
            <div class="form-group merged w-100 step-1" v-if="stepCounter === 1" :class="{ 'invalid':
                        (phone !== '' && $v.phone.$invalid) || messageBox.hasOwnProperty('phone') }">
              <label class="font-weight-bold">
                {{ $t('registration.phone') }}
              </label>
              <phone-input id="phone" v-model="phone"></phone-input>
              <button type="button" @click="begin()" :disabled="$v.phone.$invalid || errors.phone_banned"
                      class="btn btn-primary mt-5">
                {{ $t('registration.next') }}
              </button>
              <div v-if="errors.phone_banned" class="alert alert-info w-100" role="alert">
                {{ $t('registration.phone_banned') }}
              </div>
            </div>
            <div class="form-group merged w-100 step-2 mb-5" v-if="stepCounter === 2">
              <div v-show="!loading">
                <label class="font-weight-bold text-center w-100" style="font-size: 24px;">
                  {{ $t('registration.code_sms') }}
                </label>
                <PinCodeInput
                    class="d-flex justify-content-center pin-code-input"
                    :class="{ 'invalid': sms.code !== '' && $v.sms.code.$invalid }"
                    ref="pinCode"
                    onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '0'"
                    placeholder="0"
                    :length=4
                    v-model="sms.code"
                />
                <div class="text-center mt-2" v-if="!errors.phone_already_exist">
                  <a href="#" @click.prevent="sendSms"
                     :class='{disabled: (timer.seconds != 0)}'>{{ $t('registration.resend_sms') }} </a>
                  <a href="#" class="disabled" v-if="timer.seconds!==0"> ({{ timer.seconds }})</a>
                </div>

                <button type="button" @click="nextStep()" :disabled="$v.sms.code.$invalid || errors.phone_already_exist"
                        class="btn btn-primary">
                  {{ $t('registration.accept') }}
                </button>

                <div v-if="errors.sms_not_valid" class="alert alert-info w-100" role="alert">
                  {{ $t('registration.invalide_sms') }}
                </div>
                <div v-if="errors.phone_already_exist" class="alert alert-info w-100" role="alert">
                  {{ $t('registration.user_already_created_by_phone') }}
                </div>
              </div>
              <div class="text-center mt-2" v-show="loading">
                <img class="img-loading" style="width: 32px;" src="~@/assets/images/loading.gif" alt="">
                <label class="font-weight-bold">{{ $t('common.loading') }}</label>
              </div>
            </div>

            <div class="form-group merged w-100 step-3 mb-3" v-if="stepCounter === 3">
              <label class="font-weight-bold text-center w-100 mb-5"
                     style="font-size: 30px;color:#03A9F4;line-height: 30px">
                {{ findedPatient.name }}
              </label>
              <label class="font-weight-bold  w-100">
                {{ $t('registration.set_birthday') }}
              </label>
              <div class="birthday-wrapper d-flex justify-content-center">
                <PartsDateInput
                    ref="dateDay"
                    class="pin-code-input"
                    :length=2
                    @input="nextDateInput('dateDay')"
                    v-model="findedPatient.birthday[0]"
                    onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '*'"
                    placeholder="0"
                />
                <span class="slash">/</span>
                <PartsDateInput
                    ref="dateMonth"
                    class="pin-code-input"
                    :length=2
                    @input="nextDateInput('dateMonth')"
                    v-model="findedPatient.birthday[1]"
                    onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '*'"
                    placeholder="0"
                />
                <span class="slash">/</span>
                <PartsDateInput
                    ref="dateYear"
                    class="pin-code-input"
                    :length=4
                    @input="nextDateInput('dateYear')"
                    v-model="findedPatient.birthday[2]"
                    onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '*'"
                    placeholder="0"
                />
              </div>
              <button type="button" @click="nextStep()"
                      :disabled="$v.findedPatient.$invalid || loading || errors.user_with_primary_patient_already_exists_exception"
                      class="btn btn-primary">
                {{ $t('registration.yes_its_me') }}
              </button>
              <button type="button" @click="moveToRegularRegister"
                      :disabled="$v.sms.code.$invalid || loading"
                      class="cancel-btn">
                {{ $t('registration.its_not_me') }}
              </button>
            </div>
            <div class="w-100 step-4" v-if="stepCounter === 4">
              <label class="font-weight-bold text-center w-100 mb-5" style="font-size: 24px;">
                {{ $t('registration.create_password') }}
              </label>
              <div class="form-group merged w-100" :class="{ 'invalid': false}">
                <label class="font-weight-bold d-block">
                  {{ $t('registration.password') }}
                </label>
                <input id="password" type="password" class="w-100" v-model="password">
                <div style="font-size: 12px;line-height: 15px;">
                  <span class="required">* &nbsp;</span>{{ $t('registration.pass_length') }}
                </div>
              </div>
              <div class="form-group merged w-100" :class="{ 'invalid': false}">
                <label class="font-weight-bold d-block">
                  {{ $t('registration.repeat_password') }}
                </label>
                <input id="password_confirmed" type="password" class="w-100"
                       v-model="password_confirmed">
              </div>
              <button type="button" @click="createUser()" :disabled="$v.password_confirmed.$invalid ||
                            $v.password.$invalid || loading"
                      class="btn btn-primary mt-5">
                {{ $t('registration.save') }}
              </button>
            </div>
            <div v-if="errors.email_already_exists" class="alert alert-info w-100" role="alert">
              {{ $t('registration.save') }}
            </div>
          </div>
        </div>
        <div v-if="errors.user_with_primary_patient_already_exists_exception" class="alert alert-info"
             role="alert">
          {{
            $t('registration.user_account_with_primary_patient_already_exist', {number: errors.user_with_primary_patient_already_exists_exception})
          }}
          <br/>
          {{ $t('registration.call_to_support') }}
        </div>
      </div>
    </div>
    <BirthdayModal v-if="showBirthdayModal" @tryAgain="closeModal()"/>
    <LimitErrorModal v-if="limitErrorModalShow"/>
    <vue-recaptcha
        ref="recaptcha"
        size="invisible"
        :sitekey="sitekey"
        @verify="setRecaptchaToken"
        @expired="onCaptchaExpired"/>
    <div v-if="showBirthdayModal || limitErrorModalShow" class="overlay"></div>
  </div>
</template>
<script>
import { minLength, required, sameAs } from 'vuelidate/lib/validators';

import Logo from '../components/Logo';
import PhoneInput from '../components/PhoneInput';
import BirthdayModal from "../components/BirthdayModal";
import LimitErrorModal from "../components/LimitErrorModal";
import PinCodeInput from 'vue-pincode-input';
import PartsDateInput from 'vue-pincode-input';
import { VueRecaptcha } from 'vue-recaptcha';

const phoneMaskValidator = (value) => {
  return value.match(/((\+)?38)?(0\d{2}|\(0\d{2}\))(\d{7}|\d{3}-\d{2}-\d{2})/) === null ? false : true
}
export default {
  name: 'registration',
  data() {
    return {
      phone: '',
      sms: {
        code: '',
        token: '',
      },
      password: null,
      password_confirmed: null,
      findedPatient: null,
      stepCounter: 1,
      messageBox: {},
      showBirthdayModal: false,
      loading: false,
      tokenReCaptcha: '',
      timer: {
        seconds: 0,
        interval: null,
      },
      sitekey: process.env.VUE_APP_RECAPTCHA_TOKEN,
      errors: {
        email_already_exists: false,
        sms_not_valid: false,
        phone_already_exist: false,
        user_with_primary_patient_already_exists_exception: null,
        phone_banned: false
      }
    };
  },
  computed: {
    limitErrorModalShow() {
      return this.$store.getters.limitError;
    }
  },
  validations() {
    return {
      phone: {
        required,
        phoneMaskValidator
      },
      sms: {
        code: {
          required
        }
      },
      findedPatient: {
        birthday: {
          0: {
            minLength: minLength(2)
          },
          1: {
            minLength: minLength(2)
          },
          2: {
            minLength: minLength(4)
          }
        }
      },
      password: {
        required,
        minLength: minLength(8),

      },
      password_confirmed: {
        required,
        sameAsPassword: sameAs('password'),
      },


    }
  },
  methods: {
    nextDateInput(step) {
      if (step === 'dateDay') {
        this.$refs.dateMonth.$el.children[1].focus()
      }
      if (step === 'dateMonth') {
        this.$refs.dateYear.$el.children[3].focus()
      }
      if (step === 'dateYear') {
        if (this.findedPatient.birthday[1].length < 2
            &&
            this.findedPatient.birthday[0].length < 2) {
          this.$refs.dateDay.$el.children[1].focus()
        }
      }
    },
    createUser() {
      this.$store.dispatch('createUserFromPatient',
          {
            patient: this.findedPatient.id,
            password: this.password,
            confirm_password: this.password_confirmed,
            phone: this.phone.replace(/[-()\+]/g, '')
          }
      ).then(({data}) => {
        this.$router.push({name: 'registration.success', params: {type: 'registration'}})
      }).catch(error => {
        if (error.response.data.code === 'user-email-already-exists-exception') {
          this.errors.email_already_exists = true
        }
      })
    },
    sendSms() {
      this.setAccessibilityResendSMS();
      let sender = this.$store.dispatch('sendSms', {
        phone: this.phone,
        type: 'registration',
        tokenReCaptcha: this.tokenReCaptcha
      });
      sender.then(responce => {
        this.stepCounter = 2;
        this.sms.token = responce.sms_token;
      }).catch(error => {
        let errorCode = error.response.data.code;
        if (errorCode === 'sms-not-exists-exception' || errorCode === 'sms-expired-exception') {
          this.errors.sms_not_valid = true;
        }
        if (errorCode === 'phone-banned-exception') {
          this.errors.phone_banned = true;
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    checkUser() {
      return this.$store.dispatch('checkUser', {
        sms_code: this.sms.code,
        sms_token: this.sms.token
      });
    },
    moveToRegularRegister() {
      this.$router.push({name: 'registration.regular'})
    },
    closeModal() {
      this.showBirthdayModal = false
    },
    nextStep() {
      let step = this.stepCounter;
      switch (step) {
        case 1:
          this.loading = true;
          this.sendSms();
          break;
        case 2:
          this.clearTimerInterval();
          this.loading = true;
          this.checkUser().then(data => {
            this.stepCounter++;
            this.findedPatient = data;

            this.$refs.dateDay.$el.children[0].setAttribute('disabled', true)
            this.$refs.dateDay.$el.children[1].classList.add('focused')
            this.$refs.dateMonth.$el.children[0].setAttribute('disabled', true)
            this.$refs.dateMonth.$el.children[1].classList.add('focused')
            this.$refs.dateYear.$el.children[3].classList.add('focused')
            this.$refs.dateYear.$el.children[2].setAttribute('disabled', true)
            this.$refs.dateYear.$el.children[1].setAttribute('disabled', true)
            this.$refs.dateYear.$el.children[0].setAttribute('disabled', true)
          }).catch(error => {
            if (error.response.data.code === 'user-not-found-exception') {
              this.moveToRegularRegister()
            }
            if (error.response.data.code === 'sms-not-exists-exception') {
              this.errors.sms_not_valid = true;
            }
            if (error.response.data.code === 'phone-already-exist-exception') {
              this.errors.phone_already_exist = true
            }
          }).finally(() => {
            this.loading = false;
          })
          break;
        case 3:
          this.loading = true;
          let birthdayDate =
              [this.findedPatient.birthday[2], this.findedPatient.birthday[1], this.findedPatient.birthday[0]].join('-')
          this.$store.dispatch('checkUserBirthDay', {
            patient: this.findedPatient.id,
            phone: this.phone,
            birthday: birthdayDate,
          }).then(({success}) => {
            if (success) {
              this.sms.code = null;
              this.stepCounter++;
            } else {
              this.showBirthdayModal = true
            }
          }).catch(error => {
            if (error.response.data.code === 'user-with-primary-patient-already-exists-exception') {
              this.errors.user_with_primary_patient_already_exists_exception = error.response.data.context.phone
            }
          }).finally(() => {
            this.loading = false;
          })
          break;
      }
    },
    begin() {
      this.loading = true;
      this.$refs.recaptcha.execute();
    },
    setRecaptchaToken(recaptchaToken) {
      this.loading = false;
      this.tokenReCaptcha = recaptchaToken;
      this.nextStep();
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    setAccessibilityResendSMS() {
      this.timer.seconds = process.env.VUE_APP_WAIT_TIMER;
      this.clearTimerInterval();
      this.timer.interval = setInterval(() => {
        this.timer.seconds--;
        if (this.timer.seconds == 0) {
          this.clearTimerInterval();
        }
      }, 1000);
    },
    clearTimerInterval() {
      if (this.timer.interval !== null) {
        clearInterval(this.timer.interval);
        this.timer.interval = null;
      }
    }
  },
  beforeMount() {
    this.$i18n.locale = 'ua';
  },
  beforeDestroy() {
    this.clearTimerInterval();
  },
  components: {
    Logo,
    PhoneInput,
    PinCodeInput,
    BirthdayModal,
    LimitErrorModal,
    PartsDateInput,
    VueRecaptcha,
  }
  ,
}
</script>
<style>

.birthday-wrapper > .vue-pincode-input-wrapper .vue-pincode-input {
  width: 37px;
  height: 37px;
}

.slash {
  font-size: 22px;
  line-height: 54px;
  font-weight: bold;
}

button.btn-primary {
  margin-top: 20px;
}

.img-loading {
  margin-right: 15px;
}

.cancel-btn {
  width: 100%;
  border-radius: 5px;
  background-color: transparent;
  font-size: 18px;
  font-family: "ProximaNovaBold", sans-serif;
  color: #0a4766;
  margin-bottom: 20px;
  transition: .2s ease background-color;
  border: 1.5px solid #03A9F4;
  line-height: 1.5;
  vertical-align: middle;
}

.registration .pin-code-input .vue-pincode-input:focus {
  border: 1px solid #03A9F4;
  box-shadow: none;
  border-radius: 4px;

}

.registration .pin-code-input .focused {
  border: 1px solid #03A9F4;
  box-shadow: none;
  border-radius: 4px;
}

.row.main {
  max-width: 357px;
  margin: 0 auto;
}

input[type='tel']:disabled {
  background: #F8F8F8;
  border: none;
}

@media screen and (max-width: 475px) {
  .birthday-wrapper > .vue-pincode-input-wrapper .vue-pincode-input {
    width: 32px;
    height: 32px;
  }

  .registration #birthday-modal {
    width: 100%;
    height: auto;
    top: 25%;
    left: 0;
  }

  #birthday-modal .body .actions button {
    font-size: 15px;
  }

  #birthday-modal h2 {
    font-size: 22px;
  }

  #birthday-modal .header {
    padding-top: 0;
  }

  .registration #limit-error-modal {
    width: 100%;
    height: auto;
    top: 25%;
    left: 0;
  }

  #limit-error-modal .body .actions button {
    font-size: 15px;
  }

  #limit-error-modal h2 {
    font-size: 22px;
  }

  #limit-error-modal .header {
    padding-top: 0;
  }
}
</style>
